


















import Vue from 'vue';
import _ from '../../utils';

export default Vue.extend({
  data: () => ({
    error: undefined as (Error | undefined),
    vm: undefined as (Vue | undefined),
    info: undefined as (string | undefined),
  }),
  computed: {
    stackTrace() {
      try {
        const firstStackLine = this.error?.stack?.split('\n', 2).join('');
        let vueTrace = '';
        if (this.vm) {
          vueTrace = _.component.generateTrace(this.vm);
        }
        vueTrace = vueTrace
          .split('<')
          .join('&lt;')
          .split('>')
          .join('&gt;')
          .split('\n')
          .join('<br>');
        return `${firstStackLine}\n${vueTrace}`;
      } catch (e) {
        if (this.error) {
          if (this.error.stack) {
            return this.error.stack;
          }
          return this.error.toString();
        }
        return 'Unknown error, check the console';
      }
    },
  },
  methods: {
    onCloseClick() {
      this.$el.remove();
      // Cleanup component held in memory after it has been removed from DOM
      this.$destroy();
    },
  },
});
